import axios from "axios";

const API =
  process.env
    .REACT_APP_API_URL ||
  "http://localhost:5000";

export const getRoles =
  async () => {
    const res =
      await axios.get(
        `${API}/roles/all`,
        {
          withCredentials: true,
        }
      );

    return res.data;
  };

export const createRole =
  async (data) => {
    const res =
      await axios.post(
        `${API}/roles/create`,
        data,
        {
          withCredentials: true,
        }
      );

    return res.data;
  };

export const updateRole =
  async (id, data) => {
    const res =
      await axios.put(
        `${API}/roles/update/${id}`,
        data,
        {
          withCredentials: true,
        }
      );

    return res.data;
  };

export const deleteRole =
  async (id) => {
    const res =
      await axios.delete(
        `${API}/roles/delete/${id}`,
        {
          withCredentials: true,
        }
      );

    return res.data;
  };